import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { containerStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

containerStyles.topGridItem = mergeToNew(containerStyles.topGridItem, {
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
});

containerStyles.leftGridItem = mergeToNew(containerStyles.leftGridItem, {
    printWidth: 12,
    css: css`
        .leftGridItem {
            width: 100%;
            background: ${themeBackgrounds.white};
            padding: 24px;
        }

        @media print {
            max-width: 100%;
        }
    `,
});

containerStyles.spaceGridItem = mergeToNew(containerStyles.spaceGridItem, {
    printWidth: 0,
    css: css`
        @media print {
            display: none !important;
        }
    `,
});

containerStyles.rightGridItem = mergeToNew(containerStyles.rightGridItem, {
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
});
